import { IFinanceDashboardData } from 'src/apis/dashboard/dashboard.interfaces';
import { getDashboardNavigationPaths } from 'src/apis/dashboard/dashboard.helpers';

const navigationPaths = getDashboardNavigationPaths();

export const financeDashboardNewMock: IFinanceDashboardData = {
  actionItems: {
    overdue: {
      totalAmount: 245000,
      totalCount: 12,
      items: [
        {
          id: 'overdue-1',
          type: 'overdue',
          title: 'Overdue Fees - Arjun Sharma',
          description: 'Fee payment overdue by 15 days',
          amount: 15000,
          count: 1,
          priority: 'high',
          dueDate: '2024-01-15',
          relatedEntityId: 'student-001',
          relatedEntityName: 'Arjun Sharma',
          navigationPath: navigationPaths.finance.list,
        },
        {
          id: 'overdue-2',
          type: 'overdue',
          title: 'Overdue Fees - Priya Patel',
          description: 'Fee payment overdue by 8 days',
          amount: 12000,
          count: 1,
          priority: 'high',
          dueDate: '2024-01-22',
          relatedEntityId: 'student-002',
          relatedEntityName: 'Priya Patel',
          navigationPath: navigationPaths.finance.list,
        },
        {
          id: 'overdue-3',
          type: 'overdue',
          title: 'Overdue Fees - Multiple Students',
          description: '10 students with overdue fees',
          amount: 218000,
          count: 10,
          priority: 'high',
          navigationPath: navigationPaths.finance.list,
        },
      ],
    },
    partialPayments: {
      totalAmount: 125000,
      totalCount: 8,
      items: [
        {
          id: 'partial-1',
          type: 'partial',
          title: 'Partial Payment - Rohan Kumar',
          description: '₹15,000 paid out of ₹25,000',
          amount: 10000,
          count: 1,
          priority: 'medium',
          relatedEntityId: 'student-003',
          relatedEntityName: 'Rohan Kumar',
          navigationPath: navigationPaths.finance.list,
        },
        {
          id: 'partial-2',
          type: 'partial',
          title: 'Partial Payment - Ananya Reddy',
          description: '₹20,000 paid out of ₹30,000',
          amount: 10000,
          count: 1,
          priority: 'medium',
          relatedEntityId: 'student-004',
          relatedEntityName: 'Ananya Reddy',
          navigationPath: navigationPaths.finance.list,
        },
        {
          id: 'partial-3',
          type: 'partial',
          title: 'Partial Payments - Multiple Students',
          description: '6 students with partial payments',
          amount: 105000,
          count: 6,
          priority: 'medium',
          navigationPath: navigationPaths.finance.list,
        },
      ],
    },
    paymentIssues: {
      failedPayments: 5,
      refundRequests: 2,
      items: [
        {
          id: 'failed-1',
          type: 'failed_payment',
          title: 'Failed Payment - Vikram Singh',
          description: 'Payment failed - Insufficient funds',
          amount: 18000,
          count: 1,
          priority: 'high',
          relatedEntityId: 'student-005',
          relatedEntityName: 'Vikram Singh',
          navigationPath: navigationPaths.finance.reports,
        },
        {
          id: 'refund-1',
          type: 'refund_request',
          title: 'Refund Request - Meera Joshi',
          description: 'Refund request pending approval',
          amount: 25000,
          count: 1,
          priority: 'medium',
          relatedEntityId: 'student-006',
          relatedEntityName: 'Meera Joshi',
          navigationPath: navigationPaths.finance.reports,
        },
      ],
    },
  },
  upcomingItems: {
    feeDeadlines: [
      {
        id: 'deadline-1',
        type: 'fee_due',
        title: 'Term 2 Fee Deadline',
        description: 'Due date for Term 2 fees',
        dueDate: '2024-02-15',
        amount: 500000,
        count: 150,
        navigationPath: navigationPaths.finance.list,
      },
      {
        id: 'deadline-2',
        type: 'fee_due',
        title: 'Transport Fee Deadline',
        description: 'Due date for transport fees',
        dueDate: '2024-02-20',
        amount: 120000,
        count: 80,
        navigationPath: navigationPaths.finance.list,
      },
    ],
    scholarshipDisbursements: [
      {
        id: 'scholarship-1',
        type: 'scholarship_disbursement',
        title: 'Merit Scholarship Disbursement',
        description: 'Disbursement for merit scholarship recipients',
        dueDate: '2024-02-10',
        amount: 200000,
        count: 25,
        navigationPath: navigationPaths.finance.scholarships,
      },
    ],
    grantDeadlines: [],
    reportDeadlines: [
      {
        id: 'report-1',
        type: 'report_due',
        title: 'Monthly Financial Report',
        description: 'Monthly financial report submission',
        dueDate: '2024-02-05',
        navigationPath: navigationPaths.finance.reports,
      },
    ],
  },
  summary: {
    totalCollected: 2850000,
    totalDue: 370000,
    collectionRate: 88.5,
    targetAmount: 3200000,
    targetAchievement: 89.1,
    transactions: {
      total: 2850000,
      count: 245,
      byType: {
        fees: 2500000,
        income: 250000,
        expense: 100000,
      },
    },
    payments: {
      successful: 238,
      failed: 5,
      refunded: 2,
      cancelled: 0,
    },
    status: {
      paid: 220,
      partial: 8,
      unpaid: 12,
      overdue: 5,
    },
  },
  recentActivity: [
    {
      id: 'activity-1',
      type: 'collection',
      description: 'Fee collected from Aditya Verma - ₹25,000',
      amount: 25000,
      timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
      relatedEntityName: 'Aditya Verma',
      navigationPath: navigationPaths.finance.list,
    },
    {
      id: 'activity-2',
      type: 'collection',
      description: 'Fee collected from Kavya Nair - ₹18,000',
      amount: 18000,
      timestamp: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(),
      relatedEntityName: 'Kavya Nair',
      navigationPath: navigationPaths.finance.list,
    },
    {
      id: 'activity-3',
      type: 'refund',
      description: 'Refund processed for Rahul Desai - ₹12,000',
      amount: 12000,
      timestamp: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
      relatedEntityName: 'Rahul Desai',
      navigationPath: navigationPaths.finance.reports,
    },
    {
      id: 'activity-4',
      type: 'expense',
      description: 'Infrastructure maintenance - ₹45,000',
      amount: 45000,
      timestamp: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
      navigationPath: navigationPaths.finance.reports,
    },
  ],
  timeRange: {
    startDate: '2024-01-01',
    endDate: '2024-01-31',
  },
};
